export const StructureConstants = {
    GET_STRUCTURE_SUCCESS : "GET_STRUCTURE_SUCCESS",
    GET_STRUCTURE_FAILED  : "GET_STRUCTURE_FAILED",

    GET_ORG_CHART_SUCCESS : "GET_ORG_CHART_SUCCESS",
    GET_ORG_CHART_FAILURE : "GET_ORG_CHART_FAILURE",
}